import { Component, ViewChild } from '@angular/core';
import { Platform, ModalController, ViewController, Nav, App, NavController, LoadingController, AlertController } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpClient } from '@angular/common/http';

import { BasicPage } from '../pages/basic/basic';
import { UrlparsePage } from '../pages/urlparse/urlparse';

import { DataProvider } from '../providers/data/data';
import { CardProvider } from '../providers/data/data';
import { RestProvider } from '../providers/rest/rest';
//import { SqliteProvider } from '../providers/sqlite/sqlite';
// import { Keepalive } from '@ng-idle/keepalive';
import { AWS } from '../environments/environment';
import { MemberPage } from '../pages/member/member';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = UrlparsePage;
  @ViewChild(Nav) nav: Nav;
  public loading;

  constructor(platform: Platform,
    //private sqlite: SqliteProvider,
    public app: App,
    private rest: RestProvider,
    private data: DataProvider,
    private memberCard: CardProvider,
    splashScreen: SplashScreen,
    public loadingController: LoadingController,
    private alertCtrl: AlertController,) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      splashScreen.hide();
    });
    this.memberCard.color = 'red';
    this.memberCard.logoPic = 'assets/imgs/logo_procedure_new_red.png';    
  }

  public back() {
    this.memberCard.cardNo = null;
    this.memberCard.memberNo = null;
    this.memberCard.lastname = null;
    this.memberCard.name = null;
    this.memberCard.katakanaLastname = null;
    this.memberCard.katakanaName = null;
    this.memberCard.birthDay = null;
    this.memberCard.email = null;
    this.memberCard.startDate = null;
    if(document.getElementById('backFrom').innerText != '') {
      let nav = this.app.getRootNavs();
      nav[0].setRoot(MemberPage);    
    } else {      
      this.data.paymentType = '';
      let nav = this.app.getRootNavs();
      nav[0].setRoot(BasicPage);    
    }
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    return await this.loading.present();
  }

  async stopLoading() {
    return await this.loading.dismiss();
  }

  showAlert(err) {
    let alert = this.alertCtrl.create({
      title: "エラー!",
      subTitle: err,
      buttons: ["OK"]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts